import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable, runInAction } from "mobx";

class SosAlertStore {
    sosAlertList = [];
    total = 0;
    loading = false;
    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            sosAlertList: observable,
            total: observable,
            loading: observable,
            loadData: action,
            dismissSosAlert: action

        });
        this.rootStore = rootStore;
    }

    async loadData(data) {
        // this.loading = true;
        var response = await postApi
            .getClient()
            .post("index.php?c=traxi_booking&a=getSosRuleAlert", "postData=" + base64_encode(JSON.stringify(data)));


        // console.log(response.data)
        runInAction(() => {
            this.sosAlertList = response?.data?.data || [];
            this.total = parseInt(response?.data?.count) || 0;
        });
        // this.loading = false;

    }

    async dismissSosAlert(data) {
        // console.log("object", data)
        var response = await postApi
            .getClient()
            .post("index.php?c=traxi_booking&a=dismissSosRuleAlert", "postData=" + base64_encode(JSON.stringify(data)));
        return response;
    }


}

export default SosAlertStore;
